import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../App.css';
import Header from '../components/Header';
import { Helmet } from 'react-helmet-async';

type TeamVideoMember = {
  id: string;
  vimeoId: string;
  name: string;
  role: string;
  iframeTitle: string;
};

const TEAM_VIDEO_MEMBERS: TeamVideoMember[] = [
  {
    id: 'trisha',
    vimeoId: '927088335',
    name: 'Trisha Raisbeck',
    role: 'Business Services Manager.',
    iframeTitle: 'Trisha Raisbeck - Graham Care',
  },
  {
    id: 'nick',
    vimeoId: '927528280',
    name: 'Nick Bull',
    role: 'Senior Development Manager',
    iframeTitle: 'Nick Bull - Graham Care',
  },
  {
    id: 'dean',
    vimeoId: '927077552',
    name: 'Dean James',
    role: 'Compliance Manager',
    iframeTitle: 'Dean James - Graham Care',
  },
  {
    id: 'will',
    vimeoId: '927089632',
    name: 'Will Graham',
    role: 'Digital Manager',
    iframeTitle: 'Will Graham - Graham Care',
  },
];

function MeetTheTeam() {
  useEffect(() => {
    const scriptSrc = 'https://player.vimeo.com/api/player.js';
    if (document.querySelector(`script[src="${scriptSrc}"]`)) return;

    const script = document.createElement('script');
    script.src = scriptSrc;
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <>
      <Helmet>
        <title>Meet the Team | Graham Care</title>
        <meta
          name="description"
          content="Meet the Graham Care leadership team — business services, development, compliance, and digital."
        />
      </Helmet>

      <div className="page">
        <a href="#main-content" className="skip-link">
          Skip to main content
        </a>
        <Header />

        <main id="main-content">
          <section className="content-section meet-the-team-page">
            <div className="meet-the-team-container">
              <h1>Meet the Team</h1>
              <p className="meet-the-team-intro">
                Meet the people behind Graham Care — from business services and development to compliance
                and digital. Watch a short introduction from each member of our central team.
              </p>
            </div>
          </section>

          <section className="content-section meet-the-team-members" aria-label="Team members">
            <div className="meet-the-team-video-list">
              {TEAM_VIDEO_MEMBERS.map((member) => (
                <article key={member.id} className="meet-the-team-video-row">
                  <div className="meet-the-team-video__container">
                    <div className="meet-the-team-video__embed">
                      <div className="meet-the-team-video__embed-inner">
                        <iframe
                          src={`https://player.vimeo.com/video/${member.vimeoId}?badge=0&autopause=0&player_id=0&app_id=58479`}
                          title={member.iframeTitle}
                          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                          referrerPolicy="strict-origin-when-cross-origin"
                          allowFullScreen
                        />
                      </div>
                    </div>
                    <div className="meet-the-team-video__text">
                      <h2>{member.name}</h2>
                      <p>{member.role}</p>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </section>
        </main>

        <footer className="footer">
          <section className="footer__enquiry">
            <div className="footer__enquiry-container">
              <Link to="/contact-us" className="footer__enquiry-link">
                Enquire about Graham Care <span className="footer__arrow">▶</span>
              </Link>
            </div>
          </section>
          <div className="footer__container">
            <section className="contact-section">
              <div className="contact-section__content">
                <p>Graham Care Ltd, KT15 1HH</p>
                <p>Copyright © Graham Care Ltd</p>
              </div>
            </section>
          </div>
        </footer>
      </div>
    </>
  );
}

export default MeetTheTeam;
